module.exports = __webpack_public_path__ + "img/TZS09675.d202a986.jpeg";